module.exports = __webpack_public_path__ + "static/media/type_outline.ba63786f.gif";